/**
 * MCP API Service — matches grc_frontend/src/api/apiService.js pattern.
 */

const API_BASE = process.env.REACT_APP_BACKEND ?? "http://localhost:8100";

const fetchData = async (endpoint, options = {}) => {
  const backendURL = API_BASE.replace(/\/+$/, "");
  const apiUrl = `${backendURL}/api/${endpoint}`;

  const defaultHeaders = {
    "Content-Type": "application/json",
  };

  // Add API key if stored
  const apiKey = localStorage.getItem("mcp_api_key");
  if (apiKey) {
    defaultHeaders["X-API-Key"] = apiKey;
  }

  const response = await fetch(apiUrl, {
    method: options.method || "GET",
    headers: { ...defaultHeaders, ...options.headers },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  const responseText = await response.text();

  if (!response.ok) {
    let errorMessage = `API Error: ${response.status} - ${response.statusText}`;
    try {
      const data = JSON.parse(responseText);
      errorMessage = data.error || data.message || errorMessage;
    } catch (_) {
      if (responseText) errorMessage = responseText;
    }
    throw new Error(errorMessage);
  }

  return JSON.parse(responseText);
};

// ----- API functions -----

export const getHealth = () => fetchData("health/");

export const getIntegrations = () => fetchData("integrations/");

export const getTools = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return fetchData(`tools/${query ? "?" + query : ""}`);
};

export const getToolDetail = (toolName) => fetchData(`tools/${toolName}/`);

export const executeTool = (toolName, args = {}) =>
  fetchData(`tools/${toolName}/execute/`, {
    method: "POST",
    body: { arguments: args },
  });

export const executeBatch = (calls) =>
  fetchData("tools/batch/", {
    method: "POST",
    body: { calls },
  });

export default fetchData;
